import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { AppProviders } from './providers';
import Footer from '@/layouts/Footer/Footer';
import PageNavbar from '@/layouts/PageNavbar/PageNavbar';
import ScrollToHashElement from '@/layouts/ScrollToHashElement';
import { shouldShowCategoryNavbar, shouldShowPageNavbar } from '@/utils/routeUtils';
import { scrollWindowToTop } from '@/utils/scrollToTop';
import { AppRoutes } from '@/routes';
import DocumentHead from '@/components/DocumentHead';

import Navbarcategoria from '@/components/Navbarcategoria/Navbarcategoria';
import TutorialModal from '@/components/TutorialModal/TutorialModal';
import TrainingModal from '@/components/TrainingModal/TrainingModal';
import EditorModal from '@/components/EditorModal/EditorModal';

import './styles/App.css';
import './styles/design-system.css';
import './styles/pages.css';

function AppContent() {
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);
  const showCategoryNavbar = shouldShowCategoryNavbar(location.pathname);
  const showPageNavbar = shouldShowPageNavbar(location.pathname);
  const isBlogPage =
    location.pathname === '/' ||
    location.pathname === '/blog' ||
    location.pathname === '/sobre-nos' ||
    location.pathname === '/conciliacao' ||
    location.pathname === '/fullcheck' ||
    location.pathname === '/fidelidade' ||
    location.pathname === '/servicos' ||
    location.pathname === '/erp' ||
    location.pathname === '/pdv' ||
    location.pathname === '/lukos' ||
    location.pathname === '/showcase' ||
    location.pathname === '/lukos-ai' ||
    location.pathname === '/lukos-pdv' ||
    location.pathname === '/lukos-conciliacao' ||
    location.pathname === '/lukos-dashboard' ||
    location.pathname === '/lukos-fidelidade' ||
    location.pathname === '/solucoes';

  useEffect(() => {
    if (isBlogPage) {
      document.body.classList.add('no-padding-top');
    } else {
      document.body.classList.remove('no-padding-top');
    }
    return () => {
      document.body.classList.remove('no-padding-top');
    };
  }, [isBlogPage]);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    const active = document.activeElement;
    if (active instanceof HTMLElement && active !== document.body) {
      active.blur();
    }
    mainRef.current?.focus({ preventScroll: true });
    scrollWindowToTop();
    const frame = window.requestAnimationFrame(() => {
      scrollWindowToTop();
      window.requestAnimationFrame(scrollWindowToTop);
    });
    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname]);

  return (
    <div className="App">
      <DocumentHead />
      <ScrollToHashElement />
      {showCategoryNavbar && <Navbarcategoria />}
      {showPageNavbar && <PageNavbar transparent={isBlogPage} />}

      <main ref={mainRef} tabIndex={-1} className="outline-none">
        <AppRoutes />
      </main>
      <Footer />
      <TutorialModal />
      <TrainingModal />
      <EditorModal />
    </div>
  );
}

function App() {
  return (
    <AppProviders>
      <Router>
        <AppContent />
      </Router>
    </AppProviders>
  );
}

export default App;
